import { render, staticRenderFns } from "./ContactsBody.vue?vue&type=template&id=0f6bdb45&scoped=true&"
import script from "./ContactsBody.vue?vue&type=script&lang=js&"
export * from "./ContactsBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6bdb45",
  null
  
)

export default component.exports